<template>
<div class="bg-content" :style="{ backgroundImage: 'url('+homeData.urlBG+')', backgroundSize: 'auto', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat',backgroundPosition: 'top center' }" >
 <v-container id="home-content" >


        <v-layout row wrap>
      <v-flex lg3 xs12 ma-0>

      </v-flex>
      <v-flex lg6 xs12 ma-0>
              <v-card my-3>
                <v-img
                  :src="homeData.urlHead"
                >
                </v-img>

              </v-card>
              <v-card class="text-xs-center">

                <Adsense
                    data-ad-client="ca-pub-2917438270060687"
                    data-ad-slot="1978832059">
                </Adsense>
              </v-card>
        <v-card color="blue lighten-5 my-3">
          <v-card-text class="px-4" >
          <h4 class="display-1"> Дорогие друзья, мы рады сообщить, что наш сайт после разрушительной атаки восстанавливает свою работу.</h4>
          <p> Мы постарались, как можно скорее порадовать вас рабочим вариантом нашего редактора, накануне новогодних праздников.</p>
          <p> Мы в первую очередь постарались вернуть возможность сделать поздравительную открытку или приглашение на празднование Нового года.</p>
          <p> К сожалению, пока, функционал восстановлен не в полном объеме и у редактора могут наблюдаться некоторые ошибки. Но мы очень стараемся восстановить все в полном объеме.</p>
          <h6 class="title"> Итак. Что работает на данный момент:</h6>
            </v-card-text>
        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > Два раздела продуктов - <router-link to="print">"Для полиграфии"</router-link> и <router-link to="web">"Для WEB"</router-link> </v-list-tile-title>
            </v-list-tile-content>


          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе доступно 2 раздела с библиотеками изображений.  </v-list-tile-title>
            <v-list-tile-sub-title>"Фоны" - для создания подложки и "Элементы" - объекты, которые вы можете расположить на холсте</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>


        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе помимо фона и отдельного объекта можно вставить "Текст", "Прямоугольник" и "Круг".  </v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно покрасить объект или текст в любой цвет с прозрачностью.  </v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно трансформировать выделенный объект.  </v-list-tile-title>
            <v-list-tile-sub-title> Можно отзеркалить объект, переместить объект на слой выше или ниже, удалить. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно сохранить работу в формате JPEG.  </v-list-tile-title>
            <v-list-tile-sub-title> Файл сохраняется в выбранную вами папку на вашем компьютере. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>


        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе внедренна возможность сохранения состояния текущей работы.  </v-list-tile-title>
            <v-list-tile-sub-title> При возможном сбое в работе всегда будет можно получить сохраненным последнее состояние. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно  отменять совершенные действия.  </v-list-tile-title>
            <v-list-tile-sub-title> История совершенных в редакторе изменений не менее 25 шагов. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно загружать свои графические элементы.  </v-list-tile-title>
            <v-list-tile-sub-title> Формат загружаемых элементов JPG, PNG, GIF, SVG. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>


        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно сохранить и загрузить сохраненную ранее работу.  </v-list-tile-title>
            <v-list-tile-sub-title> К сожалению старые ранее сохраненные работы в большенстве не будут поддерживаться. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>


        </v-card>
        <v-card color="blue lighten-5 my-3">
          <v-card-text class="px-4" >
            <h6 class="title"> В самое ближайшее время будут добавлен следующий функционал:</h6>
          </v-card-text >

        </v-card>


        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star_border</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе можно будет сохранить результат работы в формате PDF.  </v-list-tile-title>
            <v-list-tile-sub-title> Монтаж работ на лист А4 или А3 для последующей печати на принтере. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star_border</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе будет добавлен раздел с готовыми шаблонами.  </v-list-tile-title>
            <v-list-tile-sub-title> Для каждого вида работ будет предложено не менее 10 различных шаблонов, которые вы можете использовать. </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>


        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star_border</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе будет расширен выбор шрифтов для текстового блока.  </v-list-tile-title>
            <v-list-tile-sub-title> </v-list-tile-sub-title>

            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star_border</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе будет расширен выбор типов работ. </v-list-tile-title>
            <v-list-tile-sub-title> Будут добавлены двусторонние работы, календари и расширен набор баннеров.</v-list-tile-sub-title>

            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star_border</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе будет расширен выбор графических элментов. </v-list-tile-title>
            <v-list-tile-sub-title> Будут добавлены элементы и фоны на различную тематику.</v-list-tile-sub-title>

            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star_border</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе будет добавлена возможность сохранять загруженные элементы. </v-list-tile-title>
            <v-list-tile-sub-title> Зарегистрированные пользователи смогут повторно использовать загруженные элементы из личной библиотеки.</v-list-tile-sub-title>

            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>


      </v-flex>
      <v-flex  lg3 xs12 ma-0>

      </v-flex>


    </v-layout>


<!--   <HelloWorld /> -->

</v-container>
</div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld'
import axios from "axios";
import { mapState } from "vuex";
import router from "../router";
export default {
  name: "home",
    metaInfo: {
      title: 'Cardolini - лучший он-лайн редактор изображений',
    meta: [      
      { name: 'description', content: 'Он-лайн редактор ваших баннеров, визиток, открыток и других работ' }
    ],
      // override the parent template and just use the above title only
      titleTemplate: null
    },
  components: {
     HelloWorld,
    // ScreenSaver
  },
  computed: {
    libBGTest() {
      return this.$store.state.libBGTest;
    },
    homeData() {
      return this.$store.state.homeData;
    },
  },
  mounted() {
    console.log("monted Editor");
    this.$store.commit("titleHead", "Главная");
    /* console.log("name Item =", this.$route.params.nameItem); */
    this.$nextTick(
      function() {
/*
          let swiper = new Swiper('.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 30,
              loop: false,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
          });
          console.log("swiper  = ",swiper); */
      })
  },
}
</script>
<style>
.bg-content{
 /*  background: url(/images/bgbody/bg-ny-home.jpg) no-repeat top center; */
  background-size: auto;
  background-attachment: fixed;
}
</style>